import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { ScrollAnchorId } from './helpers';

interface Props {
  scrollId: ScrollAnchorId;
}

const ScrollAnchor: FC<Props> = ({ scrollId }) => {
  useEffect(() => {
    const hash = String(window.location.hash).toLocaleLowerCase().replace('#', '');
    if (hash === scrollId) {
      const element = document.getElementById(scrollId);
      if (element) {
        setTimeout(() => {
          // Ensure the element is in the DOM before scrolling
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [scrollId]);

  return <Box id={scrollId} />;
};

export default ScrollAnchor;
